/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-array-index-key */

import CommentsSection from '../../common/CommentsSection';

const FFIEC031Comment = ({
    getFFIEC031User, ffiec031Comment, setFFIEC031Comment, commentLoading, addFFIEC031Comment,
    loading, getUserCommentsForFFIEC031, ffiec031Edit, handleFFIEC031Click, ffiec031Show,
    ffiec031Target, onFFIEC031EditClick, onFFIEC031ClickDelete, ffiec031SelectedIndex,
    ffiec031SelectedComment, setFFIEC031SelectedComment, onFFIEC031CancelClick, onFFIEC031ClickSave,
}) => (
    <CommentsSection
        getUser={getFFIEC031User}
        comment={ffiec031Comment}
        setComment={setFFIEC031Comment}
        commentLoading={commentLoading}
        addComment={addFFIEC031Comment}
        loading={loading}
        getUserComments={getUserCommentsForFFIEC031}
        edit={ffiec031Edit}
        handleClick={handleFFIEC031Click}
        show={ffiec031Show}
        target={ffiec031Target}
        onEditClick={onFFIEC031EditClick}
        onClickDelete={onFFIEC031ClickDelete}
        selectedIndex={ffiec031SelectedIndex}
        selectedComment={ffiec031SelectedComment}
        setSelectedComment={setFFIEC031SelectedComment}
        onCancelClick={onFFIEC031CancelClick}
        onClickSave={onFFIEC031ClickSave}
    />
);

export default FFIEC031Comment;
